import React from "react";

export const projectsData = [
  {
    id: 1,
    title: "A Bone to Pick Refactor MERN Stack",
    image: require("../images/bone2pick-v2.png"),
    githubLink: "https://github.com/msaylorphila/A-Bone-To-Pick-V.2",
    deployedLink: "https://a-bone-to-pick.herokuapp.com/",
  },
    {
      id: 2,
      title: "Brew Buddies",
      image: require("../images/Brew-Buddies.png"),
      githubLink: "https://github.com/miacias/brew-buddies",
      deployedLink: "https://fierce-basin-42875.herokuapp.com/",
    },
    {
      id: 3,
      title: "Horiseon",
      image: require("../images/horiseon-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/msaylor-accessibility-mod1",
      deployedLink: "https://msaylorphila.github.io/msaylor-accessibility-mod1/",
    },
    {
      id: 4,
      title: "Model-View-Controller Techblog",
      image: require("../images/mvp-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/model-view-controller-techblog",
      deployedLink: "https://mvp-techblog.herokuapp.com/",
    },
    {
      id: 5,
      title: "Vilca Events",
      image: require("../images/vilca-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/Vilca--Events",
      deployedLink: "https://glacial-escarpment-38096.herokuapp.com/",
    },
    {
      id: 6,
      title: "Workday Planner",
      image: require("../images/workday-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/msaylor-dailyplanner-mod05",
      deployedLink: "https://msaylorphila.github.io/msaylor-dailyplanner-mod05/",
    },
    {
      id: 7,
      title: "Weather Dashboard",
      image: require("../images/weather-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/msaylor-weatherapp-mod06",
      deployedLink: "https://msaylorphila.github.io/msaylor-weatherapp-mod06/",
    },
    {
      id: 8,
      title: "A Bone to Pick Volume 1: HTML, Javascript, CSS",
      image: require("../images/bone-screenshot.png"),
      githubLink: "https://github.com/msaylorphila/A-Bone-To-Pick",
      deployedLink: "https://msaylorphila.github.io/A-Bone-To-Pick/",
    },
   
  ];

  